module.exports = __webpack_public_path__ + "5f3c4d44a4cd8fa98c95752299cee918.png";